import { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    EditButton,
    ReferenceField
} from 'react-admin';


export const MiniResultsList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="metricKey" />
                <ReferenceField source="miniGrade" reference="mini_grades">
                    <TextField source="name"  />
                </ReferenceField>
                <EditButton label="View" />
            </Datagrid>
        </List>
    );
}
